<template>
  <div class="document-form">
    <h1 class="text-center" style="font-size: 42px;">{{ $t('page.document.contactUs') }}</h1>
    <p class="text-center form-tips" style="font-size: 16px;">
      {{ $t('page.document.contactUsTip') }}
    </p>
    <a-form :form="form" @submit="handleSubmit">
        <a-form-item class="form-item__required">
          <a-input
            :placeholder="$t('page.document.namePlaceholder')"
            :maxLength="50"
            v-decorator="[
              'name',
              {
                rules: [
                  {
                    required: true,
                    message: $t('page.document.nameTip'),
                  },
                ],
              },
            ]"
          />
        </a-form-item>
        <a-form-item class="form-item__required">
          <a-input
            :placeholder="$t('page.document.emailPlaceholder')"
            :maxLength="100"
            v-decorator="[
              'email',
              {
                rules: [
                  {
                    type: 'email',
                    message: $t('page.document.emailTip2'),
                  },
                  {
                    required: true,
                    message: $t('page.document.emailTip1'),
                  },
                ],
              },
            ]"
          />
        </a-form-item>
        <a-form-item>
          <a-input
            :placeholder="$t('page.document.phonePlaceholder')"
            :maxLength="15"
            v-decorator="[
              'phone',
              {
                rules: [
                  {
                    validator: validatePhone
                  }
                ],
              },
            ]"
          />
        </a-form-item>
        <a-form-item class="form-item__required">
          <a-select
            show-search
            :placeholder="$t('page.document.countryPlaceholder')"
            option-filter-prop="children"
            v-decorator="[
              'country',
              {
                rules: [{ required: true, message: $t('page.document.countryTip') }],
              },
            ]"
            :filter-option="countryFilterOption"
            @focus="handleCountryFocus"
            @blur="handleCountryBlur"
            @change="handleCountryChange"
          >
            <a-select-option v-for="item in country" :key="item.id" :value="item.name" >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item class="form-item__required">
          <a-textarea
            :auto-size="{ minRows: 7, maxRows: 7 }"
            :maxLength="3000"
            :placeholder="$t('page.document.requirementPlaceholder')"
            v-decorator="[
              'requirement',
              {
                rules: [
                  { required: true, message: $t('page.document.requirementTip') },
                ],
              },
            ]"
          />
        </a-form-item>
        <!-- <a-form-item class="text-center">
          <a-checkbox v-decorator="['agreement', { valuePropName: 'checked' }]">
            I have read the
            <a href="">
              agreement
            </a>
          </a-checkbox>
        </a-form-item> -->
        <a-form-item class="text-center">
          <a-button type="primary" html-type="submit" :loading="submitLoading">
            {{ $t('page.document.submit') }}
          </a-button>
        </a-form-item>
      </a-form>
      <div>
        <span>{{ $t('page.document.privacyTip') }}</span>&nbsp;
        <a :href="`${aihouseUrl}/reg/privacyPolicy`" target="_blank">
          {{ $t('page.document.privacyText') }}.
        </a>
      </div>
  </div>
</template>

<script>
// import { Checkbox } from 'ant-design-vue';
import country from '@/assets/country';
import { submitDocumentForm } from '@/api/document';

export default {
  name: 'DocumentForm',
  components: {
    // 'a-checkbox': Checkbox,
  },
  props: {},
  data() {
    return {
      aihouseUrl: process.env.VUE_APP_AIHOUSEURL,
      form: this.$form.createForm(this),
      country,
      submitLoading: false,
    };
  },
  watch: {},
  computed: {},
  methods: {
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          console.log('Received values of form: ', values);
          this.submitLoading = true;
          submitDocumentForm({ ...values }).then(() => {
            this.submitLoading = false;
            this.$message.success('Submit success!');
            this.form.resetFields();
          }).catch((error) => {
            this.submitLoading = false;
            this.$message.error(error.message);
          });
        }
      });
    },
    validatePhone(rule, value, callback) {
      const reg = /^[0-9]{6,15}$/;
      if (value && !reg.test(value)) {
        callback(this.$t('page.document.phoneTip'));
      }
      callback();
    },
    countryFilterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    handleCountryFocus() {

    },
    handleCountryBlur() {

    },
    handleCountryChange(value) {
      console.log(value);
    },
  },
  created() {},
  mounted() {},
};
</script>
<style lang="less" scoped>
.document-form {
  width: 100%;
  max-width: 450px;
  margin: 0 auto;
  .text-center {
    text-align: center;
  }
  .form-tips {
    margin-bottom: 30px;
  }
  & /deep/ .ant-form-item {
    position: relative;
  }
  .form-item__required:before {
    display: inline-block;
    color: #f5222d;
    font-size: 14px;
    line-height: 1;
    content: "*";
    position: absolute;
    left: -20px;
    top: 14px;
  }
}
</style>
